<div class="notification p-8">
  <div class="flex flex-row w-100-percent">
    <div [attr.color]="notification.colors.statusColor" class="traffic-light ml-16 mr-16 mt-8 ellipse"></div>
    <div [ngClass]="{'fw-100': notification.state.read}" class="title mat-headline-6">{{notification.title}}</div>
  </div>
  <div class="flex flex-col content">
    <div [ngClass]="notification.colors.messageColor" class="message">
      {{ notification.message }}
    </div>
    <div class="timestamp">
      {{notification.eventInfo.eventAt | date: 'dd.MM.yyyy'}}
    </div>

    <div *ngIf="notification.link" class="details-link">
      <a (click)="sidenavService.closeRightSidenav()" [routerLink]="['/', tenant, RouterSegments.SERVICES, notification.data?.solutionId, RouterSegments.BLUEPRINTS, notification.data?.blueprintId]"
         class="no-underline cyan-fg">
        {{ 'NOTIFICATIONS.VIEW_SERVICE' | transloco }}
      </a>
    </div>
  </div>
</div>
